import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { SearchResults } from '@/types'

export function useGlobalSearch(query: string) {
  return useQuery({
    queryKey: ['search', query],
    queryFn: async () => {
      const { data } = await api.get<{ data: SearchResults; meta: { search_mode: 'meilisearch' | 'fallback' } }>('/api/search', {
        params: { q: query, limit: 5 },
      })
      return {
        results: data.data.results,
        total: data.data.total,
        meta: data.meta,
      }
    },
    enabled: query.length >= 2,
    staleTime: 5 * 60 * 1000,
  })
}
